//client/src/pages/admin/AdminWallet.js
import { useEffect, useState } from "react";
import api from "../../api/axiosInstance";

export default function AdminWallet() {
  const [requests, setRequests] = useState([]);
  const [status, setStatus] = useState("");

  const load = async () => {
    const res = await api.get("/wallet/admin", {
      params: status ? { status } : {},
    });
    setRequests(res.data || []);
  };

  useEffect(() => {
    load();
  }, [status]);

  const act = async (id, action) => {
    await api.post(`/wallet/admin/${id}/${action}`);
    load();
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Wallet Requests</h1>

      <select
        className="input-glass max-w-xs bg-[#0b0f17] text-white"
        value={status}
        onChange={(e) => setStatus(e.target.value)}
      >
        <option value="">All</option>
        <option value="pending">Pending</option>
        <option value="approved">Approved</option>
        <option value="rejected">Rejected</option>
      </select>

      <table className="table-glass">
        <thead>
          <tr>
            <th>User</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Date</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {requests.map((r) => (
            <tr key={r._id}>
              <td>{r.user?.email}</td>
              <td>₹{r.amount}</td>
              <td>{r.status}</td>
              <td>{new Date(r.createdAt).toLocaleString()}</td>
              <td>
                {r.status === "pending" && (
                  <>
                    <button
                      onClick={() => act(r._id, "approve")}
                      className="btn-primary mr-2"
                    >
                      Approve
                    </button>
                    <button
                      onClick={() => act(r._id, "reject")}
                      className="btn-danger-sm"
                    >
                      Reject
                    </button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
